import LocationDetailButtons from '@/components/LocationDetailButtons'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		data: {},
		...opts,
		vueComponent: LocationDetailButtons
	}

	let page = vuewidget(dom, options)
	return page
}